import React, { useState } from "react";
import {
  Button,
  Form,
  notification,
  Select,
  Upload,
  Space,
  Input,
  message,
  Image,
} from "antd";
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { GrUpload } from "react-icons/gr";
import CouponsRequest from "./CouponsRequest";

import { useNavigate } from "react-router-dom";

const CreateCoupon = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [submited, setSubmit] = useState(false);
  const [form] = Form.useForm();

  const update = () => {
    setSubmit(true);
  };

    const onFinish = (values) => {
      console.log(values)
      if(submited){
      setLoading(true);
      const allFormData = { ...values };
      console.log(allFormData)
      CouponsRequest.createCoupon(allFormData)
        .then((res) => {
          if (res.status === 201) {
            notification.success({
              message: "coupon added successfully",
            });
            navigate(-1);
          } else {
            notification.error({
              message: "Something went wrong",
            });
          }
          setLoading(false);
        })
        .catch((e) => {
          setLoading(false);
          notification.error({
            message: "Failed to add coupon",
          });
          console.error("API Error:", e);
        });
      }
    };

  return (
    <section>
      <div className="Create-coupon">
        <div span={24}>
          <Form.Item className="submit-btn">
            <Space>
              <Button
                className="f-sub-btn btn-width"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                <ArrowLeftOutlined />
              </Button>
            </Space>
          </Form.Item>
        </div>
        <h3>Create Coupon</h3>

        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          initialValues={null}
          className="subscription-form"
          colon={true}
        >
          <div className="subscription">
            <Form.Item
              label="Coupon Code"
              name="couponCode"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please enter the Coupon code!" },
                {
                  pattern: /^[A-Za-z0-9]+$/,
                  message: "Coupon code can only contain alphanumeric characters!",
                },
              ]}
            >
              <Input size="large" placeholder="Enter coupon Name" />
            </Form.Item>

            <Form.Item
              label="Coupon Status"
              name="status"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please select the coupon status" },
              ]}
            >
              <Select
                placeholder="Select The coupon Status"
                // style={{ marginTop: "0.5rem", width: "99%" }}
                options={[
                  { value: "1", label: "Active" },
                  { value: "0", label: "Inactive" },
                ]}
              />
            </Form.Item>
          </div>

          <div className="subscription">
            <Form.Item
              label="Coupon Type"
              name="type"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please select the coupon type" },
              ]}
            >
              <Select
                placeholder="Select The coupon type"
                // style={{ marginTop: "0.5rem", width: "99%" }}
                options={[
                  { value: "1", label: "percentage" },
                  { value: "2", label: "Fix" },
                ]}
              />
            </Form.Item>
            <Form.Item
              label="Minimum Order Value"
              name="minimumOrderValue"
              className="subscription-plan"
              rules={[
                // { required: true, message: "Please enter the MOV!" },
                {
                  pattern: /^[0-9]+$/,
                  message: "Must be a valid number!",
                },
              ]}
            >

                    <Input size="large" placeholder="Enter MOV" />
            </Form.Item>
          </div>
          <div className="subscription">
            <Form.Item
              label="Discount Value"
              name="value"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please enter the value!" },
                  {
                  pattern: /^[0-9]+$/,
                  message: "Must be a valid number!",
                },
              ]}
            >
                   <Input size="large" placeholder="Enter Value" /> 
            </Form.Item>

            <Form.Item
              label="Owner Type"
              name="type"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please select the owner type" },
              ]}
            >
              <Select
                placeholder="Select The coupon owner type"
                // style={{ marginTop: "0.5rem", width: "99%" }}
                options={[
             
                  { value: "2", label: "Admin" },
                ]}
              />
            </Form.Item>

          </div>
          <div className="subscription">
           <Form.Item
  label="Expired At"
  name="expiredAt"
  rules={[
    { 
      required: true, 
      message: "Please select expiration date" 
    },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || value.isAfter(dayjs())) {
          return Promise.resolve();
        }
        return Promise.reject(new Error('Expiration date must be in the future'));
      },
    }),
  ]}
>
  <DatePicker 
    
    format="YYYY-MM-DD "
    style={{ width: '100%' }}
    disabledDate={(current) => {
      // Can not select days before today
      return current && current < dayjs().startOf('day');
    }}
  />
</Form.Item>

          </div>

          <div className="bottom-button">
            <div style={{ padding: "10px" }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}

                  onClick={update}
              >
                Save & Proceed
                <span>
                  <AiOutlineRight />
                </span>
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </section>
  );
};

export default CreateCoupon;
